module.exports = __webpack_public_path__ + "img/30.dda4326d.jpg";